import { render, staticRenderFns } from "./DiscoveryView.vue?vue&type=template&id=30b65710&scoped=true"
import script from "./DiscoveryView.vue?vue&type=script&lang=js"
export * from "./DiscoveryView.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryView.vue?vue&type=style&index=0&id=30b65710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b65710",
  null
  
)

export default component.exports